export function formatAge(birthDate, language = 'en') {
  if (!birthDate) return null;
  const now = new Date();
  const birth = new Date(birthDate);
  const totalMonths =
    (now.getFullYear() - birth.getFullYear()) * 12 +
    (now.getMonth() - birth.getMonth()) +
    (now.getDate() < birth.getDate() ? -1 : 0);
  const months = Math.max(0, totalMonths);
  const isEs = String(language || 'en').toLowerCase().startsWith('es');

  if (months >= 12) {
    const yrs = Math.floor(months / 12);
    return isEs
      ? `${yrs} ${yrs === 1 ? 'año' : 'años'}`
      : `${yrs} ${yrs === 1 ? 'year' : 'years'}`;
  }
  if (months >= 1) {
    return isEs
      ? `${months} ${months === 1 ? 'mes' : 'meses'}`
      : `${months} ${months === 1 ? 'month' : 'months'}`;
  }
  return isEs ? 'menos de 1 mes' : 'less than 1 month';
}

export function ageInYears(birthDate) {
  if (!birthDate) return null;
  const now = new Date();
  const birth = new Date(birthDate);
  const totalMonths =
    (now.getFullYear() - birth.getFullYear()) * 12 +
    (now.getMonth() - birth.getMonth()) +
    (now.getDate() < birth.getDate() ? -1 : 0);
  return Math.floor(Math.max(0, totalMonths) / 12);
}

/** Which sacrament form to show for a given sacrament type and age in years. */
export function getSacramentFormKind(sacramentType, age) {
  if (age === null || age === undefined) return null;
  if (sacramentType === "baptism" && age <= 6) return "infant_baptism";
  if (age >= 0 && age <= 6) return "not_applicable";
  if (age >= 7 && age <= 17) return "child";
  return "adult";
}

/** Label role for a registrant based on sacrament form kind. */
export function getRegistrantLabelKey(kind) {
  if (kind === "adult") return "_adult_n";
  if (kind === "child" || kind === "infant_baptism" || kind === "not_applicable") {
    return "_child_n";
  }
  return "_person_n";
}
